import { createSlice } from "@reduxjs/toolkit";

const usageInfoSlice = createSlice({
  name: "usageInfo",
  initialState: {
    tenantID: null,
    user: null,
    activeTab: null,
    isViewModeOn: false,
    lastRequest: null,
    lastPostRequest: null,
    poaIndex: -1,
    timerID: null,
    userReadonly: false,
    cachedLocation: "/",
    tooltips: null,
    isClientFacing: false,
    isSystemAdmin: false,
    isTenantAdmin: false,
    userGroupRole: null,
  },
  reducers: {
    setTenantID: (state, action) => {
      state.tenantID = action.payload;
    },
    setUserData: (state, action) => {
      state.user = action.payload;
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setIsViewModeOn: (state, action) => {
      state.isViewModeOn = action.payload;
    },
    setLastRequest: (state, action) => {
      state.lastRequest = action.payload;
    },
    setLastPostRequest: (state, action) => {
      state.lastPostRequest = action.payload;
    },
    setPeriodIndex: (state, action) => {
      state.poaIndex = action.payload;
    },
    setTimerID: (state, action) => {
      state.timerID = action.payload;
    },
    setUserReadonly: (state, action) => {
      state.userReadonly = action.payload;
    },
    setCachedLocation: (state, action) => {
      state.cachedLocation = action.payload;
    },
    setTooltips: (state, action) => {
      state.tooltips = action.payload;
    },
    setIsClientFacing: (state, action) => {
      state.isClientFacing = action.payload;
    },
    setIsSystemAdmin: (state, action) => {
      state.isSystemAdmin = action.payload;
    },
    setIsTenantAdmin: (state, action) => {
      state.isTenantAdmin = action.payload;
    },
    setUserGroupRole: (state, action) => {
      state.userGroupRole = action.payload;
    },
  },
});

export const {
  setTenantID,
  setUserData,
  setActiveTab,
  setIsViewModeOn,
  setLastRequest,
  setLastPostRequest,
  setPeriodIndex,
  setTimerID,
  setUserReadonly,
  setCachedLocation,
  setTooltips,
  setIsClientFacing,
  setIsSystemAdmin,
  setIsTenantAdmin,
  setUserGroupRole,
} = usageInfoSlice.actions;

export default usageInfoSlice.reducer;
